import React from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';

import { guests } from '../constants';

const Guests = () => {

    const list = [];

    for (let i = 0; i < guests.length; i++) {

        list.push(
            <Col key={i} className="" xs="12" md="6" lg="4">
                <Card className="guest-card mb-3">
                    <Card.Img variant="top" src={guests[i].img} />
                    {/* <Card.Body className="px-2 py-3 text-center">
                        <Card.Title className="text-uppercase m-0 mb-1">{guests[i].name}</Card.Title>
                        <Card.Text dangerouslySetInnerHTML={{ __html: guests[i].subTitle }}></Card.Text>
                    </Card.Body> */}
                </Card>
            </Col>
        )
    }

    return (
        <>
            <section>
                <Row id="guestSection" className="section pb-5 px-0">
                    <div className="col-12 pb-3 pt-5">
                        <div className="section-title mb-3">
                            <h1><span className="px-3">Special Guests</span></h1>
                        </div>
                    </div>
                    {list}
                </Row>
            </section>
        </>
    );
}

export default Guests;
